import React from "react";
import { Breadcrumb, Card, Col, Container, Row } from "react-bootstrap";
import contact_img from "../../Assets/images/ContactImg.png";
import { useNavigate } from "react-router-dom";
const Contact = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="main">
        <Container className="py-5 px-1">
          <Breadcrumb>
            <Breadcrumb.Item>
              <small
                className="BreadCrumbs_style"
                onClick={() => navigate("/")}
              >
                Home
              </small>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <small
                className="BreadCrumbs_style"
                onClick={() => navigate("/category/MicrosoftOffice")}
              >
                Shop
              </small>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>
              <small className="BreadCrumbs_style">Contact Us</small>
            </Breadcrumb.Item>
          </Breadcrumb>

          <Container className=" px-0">
            <Card className="Cart_Small_Card box_shadow">
              <Card.Body className="p-0">
                <Row>
                  <Col md={4} xl={4}>
                    <img
                      src={contact_img}
                      alt="AbouImg"
                      className="About_Img p-4 pt-5"
                    />
                  </Col>
                  <Col md={8} xl={8} className="About_Card_Para black_text p-5">
                    <div className="blue_bg Contact_Card_Header mb-4">
                      <Container>
                        <Row>
                          <Col className="Header_Text ps-5 ">
                            <b>Contact Us </b>
                          </Col>
                        </Row>
                      </Container>
                    </div>
                    <h6>
                      <b>Live Chat - Featuring 24/7 Support</b>
                    </h6>
                    <p>
                      Our dedicated support team is on stand-by to ensure your
                      software is up and running smoothly with minimal downtime.
                    </p>
                    <h6>
                      <b>Call Us! +1 (833) 465 0300</b>
                    </h6>
                    <p>
                      We would love to hear from you! Our sales representives
                      are available 24/7 by phone.
                    </p>
                    <h6>
                      <b>Send An Email</b>
                    </h6>
                    <p>Reach out to us by email at sales@libertyprograms.com</p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Container>
        </Container>
      </div>
    </>
  );
};

export default Contact;
